import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { CMS } from '../../Values.js';

class SidebarUserBlock extends Component {

  state = {
    showUserBlock: false,
    aDatosUsuario: {
      sNombre: sessionStorage.getItem('sNombre'),
      iIDConsultor: sessionStorage.getItem('iIDConsultor'),
      sImagen: CMS.sUrl + sessionStorage.getItem('sImagen')
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.showUserBlock !== this.props.showUserBlock) {
      this.setState({ showUserBlock: newProps.showUserBlock })
    }
  }
  render(){
    return (
      <div>
        {/* Empresa logo
        <Collapse id="user-block" isOpen={ true }>
          <div>
            <div className="item user-block">
              <div>
                <div className="col-12" style={{
                    height:"40px",
                    width:"auto",
                    backgroundImage: "url('"+this.state.aDatosUsuario.sImagen+"')",
                    backgroundPosition: "center",
                    backgroundRepeat  : 'no-repeat',
                    backgroundSize: "80px"
                  }}></div>
                </div>
                <div className="user-block-info">
                  <span className="user-block-name">{this.state.aDatosUsuario.sNombre}</span>
                </div>
              </div>
            </div>
          </Collapse>
          { Empresa logo end*/}

          <Collapse id="user-block" isOpen={ this.state.showUserBlock }>
              <div>
                <div className="item user-block">
                  {/* User picture */}
                  <div className="user-block-picture">
                    <div className="user-block-status">
                      <img className="img-thumbnail rounded-circle" src={(this.state.aDatosUsuario.sImagen != null ? this.state.aDatosUsuario.sImagen : 'images/user-default.png' )} alt="Avatar" width="60" height="60" />
                      <div className="circle bg-success circle-lg"></div>
                    </div>
                  </div>
                  {/* Name and Job */}
                  <div className="user-block-info">
                    <span className="user-block-name">{this.state.aDatosUsuario.sNombre}</span><br/>
                    <div className="">
                      <p><a href="/cambiar-imagen" >Cambiar imagen</a></p>
                      <p><a href="/cambiar-contrasena" >Cambiar contraseña</a></p>
                    </div>

                  </div>
                </div>
              </div>
          </Collapse>
        </div>

      )
    }
  }

  SidebarUserBlock.propTypes = {
    showUserBlock: PropTypes.bool
  };

  const mapStateToProps = state => ({ showUserBlock: state.settings.showUserBlock })

  export default connect(
    mapStateToProps
  )(SidebarUserBlock);
